import React from 'react';
import { Link } from 'react-router-dom';
import { PageSubTitle } from 'Components/Titles';
import { StubLabel } from 'Components/Texts';
import './ManageProfile.css';

export const ManageProfile = ({ subTitle, user, routes, trackEditAccount }) => {
  const { email, firstName, lastName, hasMvpd } = user;
  if (hasMvpd) return null;

  return (
    <div className="sectionFlex profileSettings">
      <div className="sectionFlex flexGrowOne settingsSectionLeft">
        <PageSubTitle text={subTitle} />
      </div>
      <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight">
        <div className="sectionFlex">
          <div className="sectionFlex">
            <StubLabel className="profileLabel" text="Profile:" />
            <div className="profileName">
              <div className="stubValue" data-dd-privacy="mask" data-heap-redact-text>
                {firstName} {lastName}
              </div>
            </div>
          </div>
          <div className="linksCol">
            <Link to={routes.editProfile} onClick={() => trackEditAccount('Edit Profile')} className="profileLink">
              Edit Profile
            </Link>
          </div>
        </div>

        <div className="sectionFlex sectionDivider">
          <div>
            <StubLabel className="profileLabel" text="Email:" />
            <span className="stubValue" data-dd-privacy="mask" data-heap-redact-text>
              {email}
            </span>
          </div>
        </div>
        <div className="sectionFlex">
          <div>
            <StubLabel className="profileLabel" text="Password:" />
            <span className="stubValue">............</span>
          </div>
          <div className="linksCol">
            <Link to={routes.updatePassword} onClick={() => trackEditAccount('Edit Password')} className="profileLink">
              Edit Password
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
